module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#premium",
      toString: function () {
        return this.url;
      }
    }